import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import * as actions from '../../../../store/actions'
import { commonActions, inboxActions, modalActions, sentActions, verifyActions } from '../../../../store/actions'
import { Link } from 'react-router-dom'
import moment from 'moment'
import queryString from 'query-string'
import history from '../../../../route/history'

const Modal = (props) => {
  return (
      <React.Fragment>

        <div className="modal-overlay">
          <div className="modal">
            <div className="modal-head">
              서비스 이용약관
              <a href="#" className="anchor" onClick={() => props.isOpen(false)}><img src={require('../../../../assets/images/sub/ico_close.png')} alt="팝업닫기" /></a>
            </div>

            <div className="modal-cont">
              <div className="t1">제1장 총칙</div>
              <div className="t2">제1조 (목적)</div>
              <p className="mar">본 약관은 전자무역기반사업자인 한국무역정보통신(이하 "회사"라고 함)이 인터넷사이트(wallet.utradehub.or.kr, 이하 “당 사이트”라고 함)를
                통하여 제공하는 전자무역문서지갑서비스 및 기타 이와 관련된 모든 서비스(이하 "서비스"라고 함)의 이용조건 및 절차, 이용자와 당 사이트의 권리, 의무, 책임사항과 기타 필요한 사항을
                규정함을 목적으로 합니다.</p>

              <div className="t2">제 2 조 (약관의 효력과 변경)</div>
              <p>1. 당 사이트는 이용자가 본 약관 내용에 동의하는 것을 조건으로 이용자에게 서비스를 제공할 것이며, 이용자가 본 약관의 내용에 동의하는 경우, 당 사이트의 서비스 제공 행위 및
                이용자의 서비스 사용 행위에는 본 약관이 우선적으로 적용될 것이며, 본 약관에 명시되지 않은 사항에 대해서는 회사의 인터넷사이트(www.ktnet.co.kr)에 게시된
                KTNET*전자무역인프라서비스 이용약관(이하 "인프라서비스이용약관"이라고 함)을 적용하게 될 것입니다. <br />
                  2. 당 사이트 이용자는 본 약관에 동의함으로써 인프라서비스이용약관에도 동의한 것으로 간주합니다.<br />
                  3. 회사는 본 약관을 서비스를 이용하고자 하는 자와 회원이 알 수 있도록 서비스가 제공되는 인터넷사이트(http://wallet.utradehub.or.kr)에 게시함으로써
                  공지합니다.<br />
                  4. 회사가 필요하다고 인정되는 경우, 본 약관을 변경할 수 있으며, 변경된 약관은 적용일자 및 변경사유를 명시하여 적용일자 15일전부터 적용일자 전일까지 제3항의 방법으로
                  공지함으로써 이용자가 직접 확인하도록 할 것입니다. 이용자가 변경된 약관에 동의하지 아니하는 경우, 이용자는 이용계약을 해지(이용자 탈퇴)할 수 있으며, 계속 사용의 경우는 약관
                  변경에 대한 동의로 간주됩니다. 변경된 약관은 공지한 적용일자부터 그 효력이 발생됩니다.</p>
              <br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
            </div>
            <div className="btn_area">
              <button type="button" onClick={() => props.isOpen(false)} className="btn btn-black">닫기</button>
            </div>
          </div>
        </div>

      </React.Fragment>
  )
}

const mapStateToProps = (dispatch) => {
  return {
    modal: dispatch.modal,
  }
}

const actionCreators = {
  common: commonActions.getCommonCode,
}

export default connect(mapStateToProps, actionCreators)(Modal)
